import React from "react";
import classNames from "classnames";
import "./LanguageSelectButton.scss";

const LanguageSelectButton = (props) => {
  const handleClick = () => {
    if (props.currentLang === props.lang) {
      return;
    }

    if (!!props.changeLanguage) {
      props.changeLanguage(props.lang);
    }
  };

  let imageClassNames = classNames({
    "language-select-button-img": true,
    selected: props.currentLang === props.lang,
  });

  return (
    <button
      id={props.id}
      onClick={handleClick}
      className={props.className + " language-select-button"}
    >
      <img
        className={imageClassNames}
        src={"resources/images/flags/" + props.lang + ".svg"}
        alt=""
      ></img>
    </button>
  );
};

export default LanguageSelectButton;
